import React from 'react';
import { Box, Accordion, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import EditableElement from './../EditableElement';

const Template = ({ template, setTemplate }) => {
	const handleElementChange = (sectionIndex, elementIndex, newValue) => {
		const updatedTemplate = { ...template };
		const updatedSections = [...updatedTemplate.sections];
		const updatedElements = [...updatedSections[sectionIndex].elements];

		updatedElements[elementIndex] = {
			...updatedElements[elementIndex],
			value: newValue,
		};

		updatedSections[sectionIndex] = {
			...updatedSections[sectionIndex],
			elements: updatedElements,
		};

		updatedTemplate.sections = updatedSections;
		setTemplate(updatedTemplate);
	};

	return (
		<Box>
			<Box p={2}>
				<Typography variant="h4">{template.name}</Typography>
				<Typography variant="subtitle1">Game System: {template.gameSystem}</Typography>
				<Typography variant="subtitle1">Version: {template.version}</Typography>
			</Box>
			{template.sections.map((section, sectionIndex) => (
				<Accordion key={sectionIndex} defaultExpanded sx={{ width: '700px' }}>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography variant="h6">{section.name}</Typography>
					</AccordionSummary>
					<Box sx={{ display: 'flex', flexWrap: 'wrap', p: 2 }}>
						{section.elements.map((element, elementIndex) => (
							<Box key={elementIndex} sx={{ mb: 2, mr: 2 }}>
								<EditableElement
									name={element.label}
									type={section.type}
									value={element.value}
									onChange={(newValue) =>
										handleElementChange(sectionIndex, elementIndex, newValue)
									}
								/>
							</Box>
						))}
					</Box>
				</Accordion>
			))}
		</Box>
	);
};

export default Template;
